<template>
  <ConfirmDialog></ConfirmDialog>
  <div class="align-items-center card flex grid">
    <div class="grid col-12">
      <div class="col-6">
        <table
          class="table table-bordered"
          style="width: 100%; font-size: 14px"
        >
          <tr>
            <td class="text-right"><strong>CAJA # : </strong></td>
            <td class="text-left">{{ caja.id }}</td>
          </tr>
          <tr>
            <td class="text-right"><strong>ESTADO : </strong></td>
            <td class="text-left">
              <span
                :class="
                  'border-round-2xl customer-badge p-2 ' +
                  claseEstado[caja.estado]
                "
              >
                <i
                  style="font-size: 1.3rem"
                  :class="
                    caja.estado == 1
                      ? 'font-semibold pi pi-lock-open'
                      : 'font-semibold pi pi-lock'
                  "
                ></i>
                {{ caja.estado_texto }}
              </span>
            </td>
          </tr>
          <tr>
            <td class="text-right"><strong>USUARIO : </strong></td>
            <td class="text-left">{{ caja.nombre_user }}</td>
          </tr>
          <tr>
            <td class="text-right"><strong>SUCURSAL : </strong></td>
            <td class="text-left">{{ caja.nombre_sucursal }}</td>
          </tr>
          <tr>
            <td class="text-right"><strong>F. APERTURA : </strong></td>
            <td class="text-left">{{ caja.fecha_apertura }}</td>
          </tr>
          <tr>
            <td class="text-right"><strong>F. CIERRE : </strong></td>
            <td class="text-left">{{ caja.fecha_cierre ?? "No definido" }}</td>
          </tr>
          <tr>
            <td class="text-right"><strong>SALDO INICIAL : </strong></td>
            <td class="text-left">{{ caja.saldo_inicial }} Bs</td>
          </tr>
        </table>
      </div>
      <div class="col-6">
        <table
          class="table table-bordered"
          style="width: 100%; font-size: 14px"
        >
          <tr>
            <td class="text-right"><strong>TOTAL VENTAS : </strong></td>
            <td class="text-left">{{ caja.calculo_total_ventas }} Bs</td>
          </tr>
          <tr>
            <td class="text-right"><strong>TOTAL EFECTIVO : </strong></td>
            <td class="text-left">
              {{
                convertirNumeroGermanicFormat(caja.calculo_total_saldo_caja)
              }}
              Bs
            </td>
          </tr>
          <tr>
            <td class="text-right"><strong>TOTAL QR : </strong></td>
            <td class="text-left">
              {{ convertirNumeroGermanicFormat(total_caja_qr ?? 0) }} Bs
            </td>
          </tr>
          <tr>
            <td class="text-right"><strong>TOTAL TARJETA : </strong></td>
            <td class="text-left">
              {{ convertirNumeroGermanicFormat(total_caja_tarjeta ?? 0) }} Bs
            </td>
          </tr>
          <tr>
            <td class="text-right"><strong>SALDO SEGÚN REGISTRO : </strong></td>
            <td class="text-left">
              {{
                convertirNumeroGermanicFormat(caja.recuento_efectivo ?? 0)
              }}
              Bs
            </td>
          </tr>
          <tr>
            <td class="text-right"><strong>DIFERENCIA : </strong></td>
            <td
              class="text-left"
              :style="
                caja.recuento_efectivo - caja.calculo_total_saldo_caja < 0
                  ? 'color: red; font-weight: bold'
                  : 'color: green; font-weight: bold'
              "
            >
              {{ caja.recuento_efectivo - caja.calculo_total_saldo_caja }} Bs
            </td>
          </tr>
          <tr>
            <td class="text-right"><strong>SALDO CAJA : </strong></td>
            <td class="text-left">{{ caja.calculo_total_saldo_caja }} Bs</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="grid col-12">
      <label for="observacion"
        ><strong>OBSERVACIÓN : </strong>{{ caja.observacion }}</label
      >
    </div>
  </div>

  <!-- ═══════════ VENTAS POR CATEGORÍA ═══════════ -->
  <div class="grid" v-if="'Caja Ver Detalle' in auth.user.permissions">
    <div class="card col-12">
      <div class="flex align-items-center justify-content-between mb-3">
        <h5 class="m-0"><strong>ITEMS VENDIDOS POR CATEGORÍA</strong></h5>
        <div class="flex gap-2 align-items-center">
          <span class="text-xs text-500">
            {{ totalItemsVendidos }} items · {{ ventasActivas }} ventas
          </span>
          <!-- Toggle para mostrar/ocultar totales (solo admin) -->
          <button
            class="btn-toggle-totales"
            :class="mostrarTotales ? 'btn-toggle-on' : 'btn-toggle-off'"
            @click="mostrarTotales = !mostrarTotales"
            v-tooltip.top="
              mostrarTotales ? 'Ocultar totales' : 'Mostrar totales'
            "
          >
            <i
              :class="mostrarTotales ? 'pi pi-eye-slash' : 'pi pi-eye'"
              style="font-size: 0.8rem"
            ></i>
            {{ mostrarTotales ? "Ocultar montos" : "Mostrar montos" }}
          </button>
        </div>
      </div>

      <div
        v-if="cargandoItems"
        class="flex align-items-center justify-content-center py-5"
      >
        <i
          class="pi pi-spin pi-spinner text-primary"
          style="font-size: 2rem"
        ></i>
        <span class="ml-2 text-500">Cargando items...</span>
      </div>

      <div
        v-else-if="itemsPorCategoria.length === 0"
        class="text-center py-4 text-500"
      >
        <i class="pi pi-inbox" style="font-size: 2rem"></i>
        <p class="mt-2">No hay items registrados en esta caja</p>
      </div>

      <div v-else class="categorias-grid">
        <div
          v-for="cat in itemsPorCategoria"
          :key="cat.categoria"
          class="categoria-card"
        >
          <!-- Header categoría -->
          <div class="cat-header">
            <span class="cat-nombre">{{ cat.categoria }}</span>
            <span class="cat-badge">{{ cat.totalItems }} unid.</span>
          </div>

          <!-- Items de la categoría -->
          <div class="cat-items">
            <div
              v-for="item in cat.items"
              :key="item.producto_id"
              class="cat-item-row"
            >
              <div class="cat-item-info">
                <span class="cat-item-nombre">{{ item.descripcion }}</span>
              </div>
              <div class="cat-item-right">
                <span class="cat-item-qty">×{{ item.cantidad }}</span>
                <span v-if="mostrarTotales" class="cat-item-monto">
                  Bs. {{ convertirNumeroGermanicFormat(item.subtotal) }}
                </span>
              </div>
            </div>
          </div>

          <!-- Footer con total de categoría (solo admin con toggle) -->
          <div v-if="mostrarTotales" class="cat-footer">
            <span class="cat-footer-label">Subtotal categoría</span>
            <span class="cat-footer-total"
              >Bs. {{ convertirNumeroGermanicFormat(cat.subtotal) }}</span
            >
          </div>
        </div>
      </div>

      <!-- Resumen total -->
      <div
        v-if="mostrarTotales && itemsPorCategoria.length > 0"
        class="resumen-total-items"
      >
        <div
          class="resumen-row"
          v-for="cat in itemsPorCategoria"
          :key="'r' + cat.categoria"
        >
          <span class="resumen-cat">{{ cat.categoria }}</span>
          <span class="resumen-items">{{ cat.totalItems }} items</span>
          <span class="resumen-monto"
            >Bs. {{ convertirNumeroGermanicFormat(cat.subtotal) }}</span
          >
        </div>
        <div class="resumen-total-row">
          <span class="resumen-cat font-bold">TOTAL GENERAL</span>
          <span class="resumen-items font-bold"
            >{{ totalItemsVendidos }} items</span
          >
          <span class="resumen-monto font-bold text-primary"
            >Bs. {{ convertirNumeroGermanicFormat(totalMontoItems) }}</span
          >
        </div>
      </div>
    </div>
  </div>

  <!-- Movimientos de Caja -->
  <div class="grid" v-if="caja.mov_cajas && caja.mov_cajas.length > 0">
    <div class="card col-12">
      <h5><strong>MOVIMIENTOS DE CAJA:</strong></h5>
      <DataTable
        ref="dtmovcajas"
        :value="caja.mov_cajas"
        dataKey="id"
        class="p-datatable-sm"
        stripedRows
        showGridlines
      >
        <Column>
          <template #header><i class="pi pi-cog text-xl ml-2" /></template>
          <template #body="slotProps">
            <Button
              icon="pi pi-print"
              class="p-button-icon-only p-button-raised"
              v-tooltip.top="'Imprimir Recibo'"
              @click="imprimirMovimientos(slotProps.data.id)"
            ></Button>
          </template>
        </Column>
        <Column field="id" header="ID"></Column>
        <Column field="fecha_mov" header="FECHA MOVIMIENTO"></Column>
        <Column field="tipo_mov_texto" header="TIPO MOVIMIENTO">
          <template #body="data">
            <span
              :style="data.data.tipo_mov == 1 ? 'color: green' : 'color: red'"
              >{{ data.data.tipo_mov_texto }}</span
            >
          </template>
        </Column>
        <Column
          field="concepto"
          header="CONCEPTO/MOTIVO"
          style="font-weight: bold"
        ></Column>
        <Column field="autorizado_por" header="AUTORIZADO POR"></Column>
        <Column field="importe" header="EFECTIVO" style="text-align: right">
          <template #body="data">
            <span :style="data.data.tipo_mov == 0 ? 'color: red' : ''">
              {{ data.data.tipo_mov == 0 ? "-" : ""
              }}{{ convertirNumeroGermanicFormat(data.data.importe) }}
            </span>
          </template>
        </Column>
        <Column
          field="importe_metodos_pagos"
          header="TRANSFERENCIAS"
          style="text-align: right"
        >
          <template #body="data">
            <span :style="data.data.tipo_mov == 0 ? 'color: red' : ''">
              {{ data.data.tipo_mov == 0 ? "-" : ""
              }}{{
                convertirNumeroGermanicFormat(data.data.importe_metodos_pagos)
              }}
              {{
                data.data.metodo_pago_id != 1
                  ? data.data.nombre_metodo_pago
                  : ""
              }}
            </span>
          </template>
        </Column>
        <ColumnGroup type="footer">
          <Row>
            <Column
              footer="TOTALES:"
              :colspan="6"
              footerStyle="text-align:right"
            />
            <Column class="text-right" :footer="total_efectivo" />
            <Column class="text-right" :footer="total_transferencia" />
          </Row>
        </ColumnGroup>
      </DataTable>
    </div>
  </div>

  <!-- Movimientos de Ventas -->
  <div class="grid">
    <div class="card col-12">
      <h5><strong>MOVIMIENTOS DE VENTAS:</strong></h5>
      <DataTable
        ref="detalle"
        :value="caja.ventas"
        dataKey="id"
        class="p-datatable-sm"
        stripedRows
        showGridlines
      >
        <Column>
          <template #header><i class="pi pi-cog text-xl ml-2" /></template>
          <template #body="slotProps">
            <Button
              icon="pi pi-ellipsis-v"
              class="p-button-icon-only p-button-raised"
              v-tooltip.top="'Ver Acciones'"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            ></Button>
            <Menu
              :ref="'menu' + slotProps.data.id"
              :popup="true"
              :model="acciones(slotProps.data)"
            ></Menu>
          </template>
        </Column>
        <Column class="text-right" field="id" header="COD"></Column>
        <Column field="nombre_cliente" header="CLIENTE"></Column>
        <Column field="fecha_venta" header="FECHA VENTA"></Column>
        <Column class="text-right" field="total_cancelar" header="SUBTOTAL">
          <template #body="slotProps">
            {{
              convertirNumeroGermanicFormat(
                parseFloat(slotProps.data.total_cancelar) +
                  parseFloat(slotProps.data.descuento),
              )
            }}
          </template>
        </Column>
        <Column field="descuento" header="DESCUENTO" class="text-right">
          <template #body="slotProps">{{
            convertirNumeroGermanicFormat(slotProps.data.descuento) + " Bs"
          }}</template>
        </Column>
        <Column field="total_cancelar" header="TOTAL VENTA" class="text-right">
          <template #body="slotProps">{{
            convertirNumeroGermanicFormat(slotProps.data.total_cancelar) + " Bs"
          }}</template>
        </Column>
        <Column field="calculo_efectivo" header="EFECT." class="text-right">
          <template #body="{ data }">{{
            convertirNumeroGermanicFormat(data.calculo_efectivo)
          }}</template>
        </Column>
        <Column field="total_venta_qr" header="QR" class="text-right">
          <template #body="{ data }">{{
            convertirNumeroGermanicFormat(data.total_venta_qr)
          }}</template>
        </Column>
        <Column field="total_venta_tarjeta" header="TARJETA" class="text-right">
          <template #body="{ data }">{{
            convertirNumeroGermanicFormat(data.total_venta_tarjeta)
          }}</template>
        </Column>
        <Column
          class="text-right"
          field="monto_interes_total"
          header="INTERES"
          v-if="'R_Ventas de VentasCredito' in auth.user.permissions"
        >
          <template #body="slotProps">{{
            convertirNumeroGermanicFormat(slotProps.data.monto_interes_total) +
            " Bs"
          }}</template>
        </Column>
        <Column
          class="text-right"
          field="total_venta"
          header="TOTAL COBRADO"
          v-if="'R_Ventas de VentasCredito' in auth.user.permissions"
        >
          <template #body="slotProps">{{
            convertirNumeroGermanicFormat(
              totalCobrado(
                slotProps.data.total_cancelar,
                slotProps.data.monto_interes_total,
              ),
            ) + " Bs"
          }}</template>
        </Column>
        <Column field="estado" header="ESTADO">
          <template #body="{ data }">
            <span :class="'product-badge ' + claseEstado2[data.estado]">{{
              data.estado_texto
            }}</span>
          </template>
        </Column>
        <ColumnGroup type="footer">
          <Row>
            <Column
              footer="TOTAL VENTAS:"
              :colspan="6"
              footerStyle="text-align:right"
            />
            <Column
              class="text-right"
              :footer="convertirNumeroGermanicFormat(caja.calculo_total_ventas)"
            />
          </Row>
        </ColumnGroup>
      </DataTable>
      <div class="grid mt-2 justify-content-end">
        <Button @click="goBack">
          <i class="pi pi-arrow-circle-left mr-1"></i>&nbsp;Atrás
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import CajaService from "@/service/CajaService";
import VentaService from "@/service/VentaService";
import { useAuth } from "@/stores";

export default {
  data() {
    return {
      caja: {},
      caja_id: this.$route.params.id,
      claseEstado: ["bg-", "bg-green-100", " bg-red-100"],
      claseEstado2: ["status-outofstock", "status-instock", "status-lowstock"],
      generando_pdf: false,
      medidors: [],
      total_caja_qr: 0,
      total_caja_tarjeta: 0,
      // Items por categoría
      itemsPorCategoria: [],
      cargandoItems: false,
      mostrarTotales: true, // admin puede toggle
    };
  },
  cajaService: null,
  ventaService: null,
  auth: null,
  created() {
    this.cajaService = new CajaService();
    this.ventaService = new VentaService();
    this.auth = useAuth();
  },
  mounted() {
    this.cargarCaja();
  },
  computed: {
    total_efectivo() {
      return this.convertirNumeroGermanicFormat(this.total_importe);
    },
    total_transferencia() {
      return this.convertirNumeroGermanicFormat(
        this.total_importe_metodos_pagos,
      );
    },
    totalItemsVendidos() {
      return this.itemsPorCategoria.reduce(
        (sum, cat) => sum + cat.totalItems,
        0,
      );
    },
    totalMontoItems() {
      return this.itemsPorCategoria.reduce((sum, cat) => sum + cat.subtotal, 0);
    },
    ventasActivas() {
      return (this.caja.ventas || []).filter((v) => v.estado === 1).length;
    },
  },
  methods: {
    imprimirMovimientos(id) {
      this.generando_pdf = true;
      this.cajaService.imprimirMovimientosPDF(id).then(() => {
        this.generando_pdf = false;
      });
    },
    acciones(datos) {
      return [
        {
          label: "Ver Venta",
          icon: "pi pi-fw pi-eye",
          disabled:
            "Venta Ver Detalle" in this.auth.user.permissions ? false : true,
          command: () => {
            this.detalleVenta(datos.id);
          },
        },
      ];
    },
    totalCobrado(total, interes) {
      return parseFloat(total) + parseFloat(interes);
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
      }).format(numero || 0);
    },
    detalleVenta(id) {
      this.$router.push({ name: "venta_detalle", params: { id: id } });
    },
    procesarItemsPorCategoria(ventas) {
      // Estructura que viene del backend:
      // venta.detalle_ventas = [{ producto_id, descripcion, grupo_nombre, cantidad, precio_venta }]
      // Solo ventas activas (estado === 1)
      const mapa = {};

      const ventasActivas = (ventas || []).filter((v) => v.estado === 1);

      for (const venta of ventasActivas) {
        const detalles = venta.detalle_ventas || [];
        for (const det of detalles) {
          const categoria = det.grupo_nombre || "Sin categoría";
          const productoId = det.producto_id;
          const descripcion = det.descripcion || "Producto";
          const cantidad = parseFloat(det.cantidad) || 0;
          const precio = parseFloat(det.precio_venta) || 0;

          if (!mapa[categoria]) {
            mapa[categoria] = { items: {}, subtotal: 0, totalItems: 0 };
          }
          if (!mapa[categoria].items[productoId]) {
            mapa[categoria].items[productoId] = {
              producto_id: productoId,
              descripcion,
              cantidad: 0,
              subtotal: 0,
            };
          }
          mapa[categoria].items[productoId].cantidad += cantidad;
          mapa[categoria].items[productoId].subtotal += cantidad * precio;
          mapa[categoria].subtotal += cantidad * precio;
          mapa[categoria].totalItems += cantidad;
        }
      }

      return Object.entries(mapa)
        .map(([categoria, data]) => ({
          categoria,
          items: Object.values(data.items).sort(
            (a, b) => b.cantidad - a.cantidad,
          ),
          subtotal: data.subtotal,
          totalItems: data.totalItems,
        }))
        .sort((a, b) => b.subtotal - a.subtotal);
    },
    async cargarCaja() {
      this.cargandoItems = true;
      try {
        const response = await this.cajaService.getCaja(this.caja_id);
        this.caja = response.caja;
        this.medidors = response.medidors;

        // Calcular movimientos
        let mov_cajas = this.caja.mov_cajas ?? [];
        let total_importe_metodos_pagos = 0;
        let total_importe = 0;
        for (let i = 0; i < mov_cajas.length; i++) {
          const importe_metodos = parseFloat(
            mov_cajas[i].importe_metodos_pagos,
          );
          const importe = parseFloat(mov_cajas[i].importe);
          if (mov_cajas[i].tipo_mov == 0) {
            total_importe_metodos_pagos -= importe_metodos;
            total_importe -= importe;
          } else {
            total_importe_metodos_pagos += importe_metodos;
            total_importe += importe;
          }
        }
        this.total_importe_metodos_pagos = total_importe_metodos_pagos;
        this.total_importe = total_importe;

        // QR y Tarjeta
        if (this.caja.detalle_suma_cobros_x_metodos_pago) {
          this.total_caja_qr = 0;
          this.total_caja_tarjeta = 0;
          for (const item of this.caja.detalle_suma_cobros_x_metodos_pago) {
            if (item.metodo_pago_id == 6)
              this.total_caja_qr = parseFloat(item.total);
            if (item.metodo_pago_id == 2)
              this.total_caja_tarjeta = parseFloat(item.total);
          }
        }

        // Procesar items por categoría
        this.itemsPorCategoria = this.procesarItemsPorCategoria(
          this.caja.ventas || [],
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.cargandoItems = false;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}

/* ════ ITEMS POR CATEGORÍA ════ */
.categorias-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.categoria-card {
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.cat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem 0.9rem;
  background: linear-gradient(135deg, #1e293b, #334155);
}
.cat-nombre {
  font-size: 0.82rem;
  font-weight: 800;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.cat-badge {
  font-size: 0.72rem;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.15);
  color: #e2e8f0;
  padding: 2px 8px;
  border-radius: 20px;
}

.cat-items {
  padding: 0.4rem 0;
}

.cat-item-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.35rem 0.9rem;
  border-bottom: 1px solid #f1f5f9;
  gap: 0.5rem;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: #f8fafc;
  }
}

.cat-item-info {
  flex: 1;
  min-width: 0;
}
.cat-item-nombre {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.cat-item-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}
.cat-item-qty {
  font-size: 0.85rem;
  font-weight: 800;
  color: #f97316;
  min-width: 28px;
  text-align: center;
}
.cat-item-monto {
  font-size: 0.8rem;
  font-weight: 700;
  color: #475569;
  white-space: nowrap;
}

.cat-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.9rem;
  background: #f1f5f9;
  border-top: 2px solid #e2e8f0;
}
.cat-footer-label {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 600;
}
.cat-footer-total {
  font-size: 0.95rem;
  font-weight: 900;
  color: #1e293b;
}

/* Resumen total */
.resumen-total-items {
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}
.resumen-row {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 1rem;
  padding: 0.4rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  font-size: 0.85rem;
  &:hover {
    background: #f8fafc;
  }
}
.resumen-total-row {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 1rem;
  padding: 0.6rem 1rem;
  background: linear-gradient(135deg, #1e293b, #334155);
  color: #fff;
  font-size: 0.9rem;
}
.resumen-cat {
  font-weight: 600;
  color: inherit;
}
.resumen-items {
  color: #94a3b8;
  font-weight: 600;
  text-align: right;
}
.resumen-monto {
  font-weight: 800;
  text-align: right;
  min-width: 100px;
}
.resumen-total-row .resumen-items {
  color: #94a3b8;
}
.resumen-total-row .resumen-monto {
  color: #fbbf24;
}

/* Toggle botón */
.btn-toggle-totales {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  border: 1.5px solid;
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-toggle-on {
  background: #f0fdf4;
  border-color: #16a34a;
  color: #15803d;
  &:hover {
    background: #dcfce7;
  }
}
.btn-toggle-off {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #64748b;
  &:hover {
    background: #f1f5f9;
  }
}

@media (max-width: 768px) {
  .categorias-grid {
    grid-template-columns: 1fr;
  }
  .resumen-row,
  .resumen-total-row {
    grid-template-columns: 1fr auto;
  }
  .resumen-items {
    display: none;
  }
}
</style>